import { ApiError, handleApiError } from '@/handleApiError'
import api from '@/modules/user/api'
import { GuestUser } from '@/modules/user/types'
import { ContactTitle } from '@/types/types.gen'
import * as Sentry from '@sentry/vue'
import { defineStore } from 'pinia'

interface GuestUserState {
  guestUser: GuestUser
  loading: boolean
}

const initialState = (): GuestUserState => {
  return {
    guestUser: {
      title: ContactTitle.UNSPECIFIED,
      firstName: '',
      lastName: '',
      email: '',
      isRegistred: false,
      isDuplicateUser: false
    },
    loading: false
  }
}

const useGuestUser = defineStore('guestUser', {
  state: () => initialState(),
  actions: {
    async initGuestUserSession() {
      return api
        .getGuestUser()
        .then(({ data }) => {
          this.guestUser = data
          Sentry.getCurrentScope().setUser({
            email: data.email
          })
        })
        .catch((error: ApiError) => {
          handleApiError(error, undefined, {
            errorCode: 404,
            logError: false,
            appearance: 'NONE'
          })
        })
    }
  }
})

export default useGuestUser
